import { render, staticRenderFns } from "./JobCommentsPage.vue?vue&type=template&id=4a0dc485&scoped=true"
import script from "./JobCommentsPage.vue?vue&type=script&lang=js"
export * from "./JobCommentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0dc485",
  null
  
)

export default component.exports